import { Box, Button, Typography } from "@material-ui/core";
import { X, User, Database } from "phosphor-react";
import useManageDowngradeModalStyles from "./ManageDowngradeModalStyles";

const BYTES_IN_GB = 1024 * 1024 * 1024;

const ManageDowngradeModal = ({
  handleClose,
  currentTierDetails,
  selectedPlan,
}) => {
  const classes = useManageDowngradeModalStyles();

  const currentUsers = currentTierDetails?.total_users || 0;
  const currentStorageBytes = currentTierDetails?.total_storage || 0;
  const currentStorageGB = (currentStorageBytes / BYTES_IN_GB).toFixed(2);

  const newUserLimit = Number(selectedPlan?.seats || 0);
  const newStorageLimitGB = Number(selectedPlan?.storage || 0);

  const isUserExceeded = currentUsers > newUserLimit;
  const isStorageExceeded =
    currentStorageBytes > newStorageLimitGB * BYTES_IN_GB;

  return (
    <Box className={classes.modalWrapper}>
      {/* Header */}
      <Box className={classes.header}>
        <Typography className={classes.title}>Manage Downgrade</Typography>
        <Button onClick={handleClose}>
          <X size={22} color="#F9F9F9" />
        </Button>
      </Box>

      {/* Body */}
      <Box className={classes.body}>
        <Typography className={classes.description}>
          You&apos;ve exceeded the limits for downgrading your plan. Please
          adjust the following items to meet the acceptable limits before
          proceeding.
        </Typography>

        {/* Table */}
        <Box className={classes.tableWrapper}>
          {/* Header */}
          <Box className={classes.tableHeader}>
            <Box className={classes.colLabel}></Box>
            <Box className={classes.colCurrent}>
              Current : {currentTierDetails?.tier}
            </Box>
            <Box className={classes.colNew}>
              New Limits : {selectedPlan?.label}
            </Box>
          </Box>

          {/* Team Seats */}
          <Box className={classes.row}>
            <Box className={classes.colLabel}>
              <User size={18} /> Team Seats
            </Box>

            <Box className={classes.colCurrent}>{currentUsers}</Box>

            <Box
              className={isUserExceeded ? classes.colNewError : classes.colNew}
            >
              {currentUsers} / {newUserLimit}
            </Box>
          </Box>

          {/* Storage */}
          <Box className={classes.row}>
            <Box className={classes.colLabel}>
              <Database size={18} /> Storage
            </Box>

            <Box className={classes.colCurrent}>{currentStorageGB} GB</Box>

            <Box
              className={
                isStorageExceeded ? classes.colNewError : classes.colNew
              }
            >
              {currentStorageGB} GB / {newStorageLimitGB} GB
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ManageDowngradeModal;
